import { ResendInvitationStatus } from "../@types/ResendInvitationStatus";

export default async function resendInvite(
  token: string | null,
): Promise<ResendInvitationStatus> {
  if (token === null || token.trim().length === 0) {
    return { status: "error", message: "Invalid token" };
  }

  let response: Response;
  try {
    response = await callApi(token);
  } catch (e) {
    return { status: "error", message: "Network error" };
  }

  console.log("Response: ", response);
  if (response.ok) {
    return {
      status: "ok",
      message: "Invitation resent successfully",
    };
  }
  return {
    status: "error",
    message: "Failed to resend invitation",
  };
}

async function callApi(token: string): Promise<Response> {
  const url = new URL(window.REACT_APP_API_URL + "/resend-invitation");

  return fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    credentials: "include",
  });
}
